






































































































import Vue, { PropType } from 'vue';
import {
  BrandData,
  Item,
  Lineup,
  lineup as lineupM,
  options,
} from 'mostra';

import { v4 } from 'uuid';

const {
  createLineupGroupTitle,
  createLineupItems,
  createLineupGroupDescription,
} = lineupM;

const generateListKey = () => v4();

type BrandLineupItem = {
  id: string,
  lineup: Lineup,
}

interface DataType {
  isFrameSelectMode: boolean;
  selectedLineupLayout: number | null;
  selectedLineupItemIds: string[];
  blockIndex: number;
  loading: boolean;
  lineupItemOptions: Item[];
  maxLineupItemIndex: number;
  categoryOptions: object[];
  isSelectModalOpen: boolean;
  currentIndex: number;
  listLength: number;
  maxDisplayedItemLength: number;
  pagerLength: number;
  maxPagerLength: number;
  listItems: Item[];
  pagerItems: number[];
}

export default Vue.extend({
  name: 'GBrandItem',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    brand: Object as PropType<BrandData>,
    items: Array as PropType<Item[]>,
  },
  data(): DataType {
    return {
      isFrameSelectMode: false,
      selectedLineupLayout: null,
      selectedLineupItemIds: [],
      blockIndex: 0,
      maxLineupItemIndex: 0,
      categoryOptions: [
        { text: '全てのカテゴリ', value: 0 },
        ...options.itemCategories,
      ],
      lineupItemOptions: this.items,
      isSelectModalOpen: false,
      loading: false,
      currentIndex: 1,
      listLength: 0,
      maxDisplayedItemLength: 30,
      pagerLength: 0,
      maxPagerLength: 8,
      listItems: [],
      pagerItems: [],
    };
  },
  computed: {
    lineups(): BrandLineupItem[] {
      return this.brand.lineup.map((lineup: Lineup) => (
        {
          id: generateListKey(),
          lineup: lineup,
        }
      ));
    },
  },
  watch: {
    lineupItemOptions(array: any) {
      if (array) {
        this.listLength = array.length;
        this.pagerLength = Math.ceil(
          array.length / this.maxDisplayedItemLength,
        );
        this.createList(this.currentIndex);
      }
    },
    currentIndex(index: number) {
      this.createList(index);
    },
  },
  methods: {
    generateListKey() {
      return v4();
    },
    setMaxLineupItemIndex() {
      const frameType = this.brand.lineup[this.blockIndex].frameType;
      if (frameType === 1) {
        this.maxLineupItemIndex = 3;
        return;
      }
      if (frameType === 2) {
        this.maxLineupItemIndex = 3;
        return;
      }
      if (frameType === 3) {
        this.maxLineupItemIndex = 5;
        return;
      }
      if (frameType === 6) {
        this.maxLineupItemIndex = 2;
        return;
      }
      if (frameType === 7) {
        this.maxLineupItemIndex = 1;
        return;
      }
      if (frameType === 101) {
        this.maxLineupItemIndex = 3;
        return;
      }
      if (frameType === 102) {
        this.maxLineupItemIndex = 2;
        return;
      }
      if (frameType === 103) {
        this.maxLineupItemIndex = 1;
        return;
      }
      this.maxLineupItemIndex = 0;
    },
    onDeleteParts(targetIndex: number) {
      return () => {
        this.brand.lineup.splice(targetIndex, 1);
      };
    },
    onSwapLineupPosition(mode: 'up' | 'down', targetIndex: number) {
      return () => {
        let swapTargetIndex = 0;
        if (mode === 'up') {
          if (targetIndex === 0) return;
          swapTargetIndex = targetIndex - 1;
        }
        if (mode === 'down') {
          if (targetIndex === this.brand.lineup.length - 1) return;
          swapTargetIndex = targetIndex + 1;
        }
        const copiedPickups = [...this.brand.lineup];
        copiedPickups[swapTargetIndex] = this.brand.lineup[targetIndex];
        copiedPickups[targetIndex] = this.brand.lineup[swapTargetIndex];
        this.brand.lineup = copiedPickups;
      };
    },
    onDeleteLineupItem(targetIndex: number, lineupIndex: number) {
      // MEMO targetIndex: 商品のindex, lineupIndex: ラインアップのindex
      return () => {
        const targetLineup: Lineup = this.brand.lineup[lineupIndex];
        if (!targetLineup.itemIds) return;
        targetLineup.itemIds.splice(targetIndex, 1);
      };
    },
    onSwapLineupItemPosition(
      mode: 'up' | 'down',
      targetIndex: number,
      lineupIndex: number,
    ) {
      return () => {
        let swapTargetIndex = 0;
        const targetLineup: Lineup = this.brand.lineup[lineupIndex];
        if (!targetLineup.itemIds) return;

        if (mode === 'up') {
          if (targetIndex === 0) return;
          swapTargetIndex = targetIndex - 1;
        }

        if (mode === 'down') {
          if (targetIndex === targetLineup.itemIds.length - 1) return;
          swapTargetIndex = targetIndex + 1;
        }
        const copiedLineupItemIds = [...targetLineup.itemIds];
        copiedLineupItemIds[swapTargetIndex] = targetLineup.itemIds[targetIndex];
        copiedLineupItemIds[targetIndex] = targetLineup.itemIds[swapTargetIndex];
        this.brand.lineup[lineupIndex].itemIds = copiedLineupItemIds;
      };
    },
    addLineupBlock() {
      if (!this.selectedLineupLayout) return;
      // MEMO 選択中のラインアップのvalueをみて追加するラインアップを切り替える
      const newLineupBlock = (() => {
        switch (this.selectedLineupLayout) {
          case 4: return createLineupGroupTitle();
          case 5: return createLineupGroupDescription();
          default: return createLineupItems(this.selectedLineupLayout ?? 1);
        }
      })();
      this.brand.lineup = [...this.brand.lineup, newLineupBlock];
      // MEMO ラインアップブロック追加後は選択中のラインアップをリセットしブロック追加表示を切り替える
      this.selectedLineupLayout = null;
      this.switchFrameSelectMode();
    },
    switchFrameSelectMode() {
      this.isFrameSelectMode = !this.isFrameSelectMode;
    },
    onClickSelectLineupItem(targetLineupIndex: number) {
      return () => {
        const targetLineup: Lineup = this.brand.lineup[targetLineupIndex];
        if (!targetLineup.itemIds) return;
        this.blockIndex = targetLineupIndex;
        this.selectedLineupItemIds = [...targetLineup.itemIds];
        this.setMaxLineupItemIndex();
        this.openSelectItemModal();
      };
    },
    onSelectLienupLayout(val: number) {
      this.selectedLineupLayout = val;
    },
    setLineupItemOptions() {
      this.lineupItemOptions = [...this.items];
      this.listItems = this.lineupItemOptions;
    },
    onCategoryChange(value: number) {
      if (!value) {
        this.lineupItemOptions = [...this.items];
      } else {
        this.lineupItemOptions = this.items.filter(
          (itemValue: Item) => value === itemValue.data.category.categoryId,
        );
      }
      this.listItems = this.lineupItemOptions;
      this.currentIndex = 1;
    },
    createList(index: number) {
      const startIndex = (index - 1) * this.maxDisplayedItemLength;
      this.listItems = [];
      for (let i = 0; i < this.maxDisplayedItemLength; i++) {
        if (!this.lineupItemOptions[startIndex + i]) break;
        this.listItems.push(this.lineupItemOptions[startIndex + i]);
      }
    },
    setPagerItems(list: number[]) {
      this.pagerItems = list;
    },
    prevPage() {
      if (this.currentIndex <= 1) return;
      this.currentIndex--;
    },
    changePage(index: number) {
      this.currentIndex = index;
    },
    nextPage() {
      if (this.currentIndex >= this.pagerLength) return;
      this.currentIndex++;
    },
    onClickSelectDone() {
      this.brand.lineup[this.blockIndex].itemIds = this.selectedLineupItemIds;
      this.closeSelectItemModal();
    },
    openSelectItemModal() {
      this.isSelectModalOpen = true;
    },
    closeSelectItemModal() {
      this.blockIndex = 0;
      this.selectedLineupItemIds = [];
      this.isSelectModalOpen = false;
    },
  },
  async mounted() {
    this.setLineupItemOptions();
  },
});
